// Fasce orarie selezionabili nei form di presenze/turni: 09:00-24:00 a step di 15 minuti
export const ORARI = [];
for (let h = 9; h <= 23; h++) {
  ORARI.push(`${String(h).padStart(2,'0')}:00`);
  ORARI.push(`${String(h).padStart(2,'0')}:15`);
  ORARI.push(`${String(h).padStart(2,'0')}:30`);
  ORARI.push(`${String(h).padStart(2,'0')}:45`);
}
ORARI.push('24:00');
